import React from "react";
import { Link } from "react-router-dom";
import { Tv, Zap, ChevronRight, Shield, Check, Phone, Mail, Star } from "lucide-react";

export default function TemplateModernDark({ site }) {
  const { brand_name, phone, email, products, headline, tagline } = site;
  return (
    <div className="min-h-screen bg-[#0f0f1a] text-white font-body">
      {/* Nav */}
      <nav className="border-b border-white/10 backdrop-blur-md bg-[#0f0f1a]/80 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-brand-primary to-brand-accent flex items-center justify-center"><Tv className="w-5 h-5" /></div>
            <span className="font-heading font-bold text-xl">{brand_name || "DTH Portal"}</span>
          </div>
          <div className="flex gap-3">
            <a href="#plans" className="text-sm text-white/60 hover:text-white mt-2">Plans</a>
            <Link to="login" className="bg-gradient-to-r from-brand-primary to-brand-accent px-4 py-2 rounded-lg text-sm font-semibold hover:opacity-90">Login</Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,var(--brand-primary),transparent_60%)] opacity-20" />
        <div className="max-w-4xl mx-auto text-center relative">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-brand-primary bg-white/10 text-xs font-semibold border border-white/20">
            <Star className="w-3 h-3" /> Premium DTH Service
          </span>
          <h1 className="mt-6 font-heading font-black text-5xl md:text-7xl leading-tight">
            {headline ? (
              <span className="bg-gradient-to-r from-brand-primary to-brand-accent bg-clip-text text-transparent">{headline}</span>
            ) : (
              <>Entertainment<br /><span className="bg-gradient-to-r from-brand-primary to-brand-accent bg-clip-text text-transparent">Reimagined.</span></>
            )}
          </h1>
          <p className="mt-6 text-white/50 text-lg max-w-xl mx-auto">
            {tagline || "Lightning-fast DTH recharge with the most competitive plans. Your entertainment, your way."}
          </p>
          <div className="mt-8 flex gap-3 justify-center">
            <button className="bg-gradient-to-r from-brand-primary to-brand-accent px-8 py-4 rounded-xl font-bold text-lg hover:opacity-90 transition-all flex items-center gap-2">
              <Zap className="w-5 h-5" /> Recharge Now
            </button>
          </div>
        </div>
      </section>

      {/* Plans */}
      <section id="plans" className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading font-bold text-3xl text-center">Choose Your Plan</h2>
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {(products || []).slice(0, 6).map((p, i) => (
              <div key={p.id || i} className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all group">
                <p className="text-xs text-brand-primary uppercase font-semibold tracking-wider">{p.category || p.operator}</p>
                <h3 className="font-heading font-bold text-xl mt-2">{p.name}</h3>
                <p className="font-heading font-bold text-4xl mt-4 bg-gradient-to-r from-brand-primary to-brand-accent bg-clip-text text-transparent">₹{p.sell_price}</p>
                <p className="text-sm text-white/40 mt-1">{p.validity_days} days</p>
                <button className="mt-6 w-full bg-white/10 hover:bg-brand-primary border border-white/10 py-3 rounded-xl font-semibold transition-all flex items-center justify-center gap-1">
                  Get Plan <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
          {(!products || products.length === 0) && <p className="text-center text-white/30 mt-8">Plans coming soon.</p>}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-8 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2"><Tv className="w-5 h-5 text-brand-primary" /><span className="font-heading font-bold">{brand_name}</span></div>
          <div className="flex gap-4 text-sm text-white/40">
            {phone && <span className="flex items-center gap-1"><Phone className="w-4 h-4" />{phone}</span>}
            {email && <span className="flex items-center gap-1"><Mail className="w-4 h-4" />{email}</span>}
            <Link to="privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
          </div>
        </div>
        <div className="max-w-6xl mx-auto mt-8 pt-4 border-t border-white/10 text-center text-xs text-white/40">
          Powered by : Oxiaim Techbreed Pvt. Ltd.
        </div>
      </footer>
    </div>
  );
}
